'use client';

function isProxyDate(value) {
    var _a = Proxy.revocable(new Date(), {}), proxy = _a.proxy, revoke = _a.revoke;
    var isProxy = value instanceof proxy.constructor;
    revoke();
    return isProxy;
}

export { isProxyDate as default };
//# sourceMappingURL=isProxyDate.js.map
